import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import WorkersList from "components/menu/master-files/workers-maintenance/list";

const WorkersMaintenanceRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={WorkersList}
            />
        </Switch>
    </div>
);

export default connect()(WorkersMaintenanceRouter);
